<script>
import ModalWrapperChoice from "@/components/modals/ModalWrapperChoice";
import SaveInfoEntry from "@/components/modals/cloud/SaveInfoEntry";

export default {
  name: "CloudSaveConflictModal",
  components: {
    ModalWrapperChoice,
    SaveInfoEntry,
  },
  computed: {
    conflict() {
      return this.$viewModel.modal.cloudConflict;
    },
    older() {
      return this.conflict.saveComparison.older === -1;
    },
    farther() {
      return this.conflict.saveComparison.farther === -1;
    },
    hasDifferentName() {
      return this.conflict.cloud.saveName !== this.conflict.local.saveName;
    },
    wrongHash() {
      return this.conflict.saveComparison.hashMismatch;
    },
    suggestionText() {
      const goodStyle = `style="color: var(--color-good)"`;
      const badStyle = `style="color: var(--color-infinity)"`;

      const suggestions = ["Сохранение в Облако "];
      const cloudProg = this.conflict.cloud.compositeProgress, localProg = this.conflict.local.compositeProgress;
      const warnOverwrite = this.farther && Math.abs(cloudProg - localProg) > 0.15;
      suggestions.push(warnOverwrite
        ? `<b ${badStyle}>перезапишет сохранение с значительно большим количеством прогресса</b>`
        : `<b ${goodStyle}>скорее всего безопасно</b>`);
      if (this.hasDifferentName || this.wrongHash) {
        suggestions.push(` ${warnOverwrite ? "Дополнительно" : "Однако"} вы можете перезаписывать 
          <b ${badStyle}>сохранение с другого устройства</b>.`);
      }
      if (warnOverwrite || this.hasDifferentName || this.wrongHash) {
        suggestions.push(`<br><b ${badStyle}>Вы уверены, что хотите перезаписать Облачное сохранение?</b>`);
      }
      return suggestions.join("");
    },
    noOverwriteInfo() {
      return `Конфликты сохранений продолжат появляться без перезаписи.`;
    },
    overwriteInfo() {
      return `Если другое устройство тоже сохраняет в Облако в текущий момент,
        это меню может появляться постоянно.`;
    }
  },
  methods: {
    doNotSave() {
      player.options.cloudEnabled = false;
      EventHub.dispatch(GAME_EVENT.CLOSE_MODAL);
    },
    overwrite() {
      this.conflict.onAccept?.();
      EventHub.dispatch(GAME_EVENT.CLOSE_MODAL);
    }
  },
};
</script>

<template>
  <ModalWrapperChoice
    class="c-modal-options__large"
    :cancel-class="'c-modal-message__okay-btn'"
    :confirm-class="'c-modal-message__okay-btn c-modal__confirm-btn'"
    :cancel-fn="overwrite"
    @confirm="doNotSave()"
  >
    <template #header>
      Сохранить Игру в Облако
    </template>
    <span v-if="wrongHash">
      Ваше Облачное Сохранение было <b>изменено другим устройством</b> с момента, когда вы последний раз сохранялись
      в Облако в этой сессии.
    </span>
    <span v-else-if="hasDifferentName">
      Ваше Локальное и Облачное сохранения имеют <b>разные имена</b>.
    </span>
    <span v-else-if="older">
      Сохранение в Облако <b>перезапишет более старое сохранение</b>.
    </span>
    <span v-else-if="farther">
      Сохранение в Облако <b>перезапишет сохранение с большим количеством прогресса</b>.
    </span>
    <span v-else>
      Ваше Локальное и Облачное сохранения <b>имеют примерно одинаковое количество прогресса</b>.
    </span>
    <br>
    <SaveInfoEntry
      :save-data="conflict.local"
      :other-data="conflict.cloud"
      :save-id="conflict.saveId"
      :show-name="hasDifferentName"
      save-type="Локальное Сохранение"
    />
    <SaveInfoEntry
      :save-data="conflict.cloud"
      :other-data="conflict.local"
      :save-id="conflict.saveId"
      :show-name="hasDifferentName"
      save-type="Облачное Сохранение"
    />
    <span v-html="suggestionText" />
    <br>
    <span>
      Не перезаписывание отключит Облачное сохранение и вам придётся вручную включить его, если вы захотите его
      использовать.
      <span :ach-tooltip="noOverwriteInfo">
        <i class="fas fa-question-circle" />
      </span>
    </span>
    <span>
      Перезаписывание сделает сохранение текущей игры в Облако; в большинстве
      случаев это предотвратит последующие появления данного меню.
      <span :ach-tooltip="overwriteInfo">
        <i class="fas fa-question-circle" />
      </span>
    </span>
    <template #cancel-text>
      Перезаписать Облачное Сохранение
    </template>
    <template #confirm-text>
      Не перезаписывать
    </template>
  </ModalWrapperChoice>
</template>
